// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DispatchResetOrderApprovals,
    SendTracking,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { xGoogleAnalyticsState } from "@tps/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@tps/App/GoogleAnalyticsConnector/Utilities/DataLayer";

export const XngGaSendTracking: typeof DispatchResetOrderApprovals = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const updatedCart = { ...props.cartToUpdate, orderNumber: props.apiResult.cart.orderNumber };
    const session = getSession(props.getState());

    if (state.xGoogleAnalytics.purchaseEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }
        const { apiResult } = props;

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.purchaseEventName,
            transaction_id: apiResult.cart.orderNumber,
            value: apiResult.cart.orderSubTotal,
            tax: apiResult.cart.totalTax,
            shipping: apiResult.cart.shippingAndHandling,
            currency: session.currency?.currencyCode,
            coupon: apiResult.cart.promotionCode,
            affiliation: apiResult.billTo?.companyName,
            user: session?.userProfileId,
            customer_number: apiResult.billTo?.customerNumber,
            company_name: apiResult.billTo?.companyName,
            cart_value: apiResult.cart.orderSubTotal,
            customer_id: session?.billToId,
            items: updatedCart.cartLines?.map((cartLine, idx) => ({
                item_id: cartLine.erpNumber,
                item_name: cartLine.shortDescription,
                affiliation: apiResult.billTo?.companyName,
                coupon: apiResult.cart.promotionCode,
                discount: cartLine.pricing
                    ? cartLine.pricing.unitNetPrice < cartLine.pricing.unitListPrice
                        ? cartLine.pricing.unitListPrice - cartLine.pricing.unitNetPrice
                        : 0
                    : 0,
                index: idx,
                item_brand: state.xGoogleAnalytics.includeProductBrand ? cartLine.brand?.name || "" : undefined,
                item_category: state.xGoogleAnalytics.includeProductCategory
                    ? cartLine.properties?.["category"] || ""
                    : undefined,
                item_list_id: state.xGoogleAnalytics.includeProductCategory
                    ? cartLine.properties?.["categoryId"] || ""
                    : undefined,
                locationId: session.pickUpWarehouse?.id,
                price: cartLine.pricing?.unitNetPrice,
                quantity: cartLine.qtyOrdered,
            })),
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToChainAfter(chain, SendTracking, XngGaSendTracking);
